module.exports = __webpack_public_path__ + "static/img/Josh-Kerr.e7587a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Josh-Kerr.jpg
// module id = huk8
// module chunks = 0